<div style="height: 100%; width: 100%;">

  <div class="fx-layout-row" style="height: 100%;">

    <div class="fx-flex-38 fx-hide-lt-md">
      <img class="image1" src="../../../../assets/images/login1.png">
    </div>

    <div class="fx-flex-62 fx-flex-lt-md-100">
      <img class="image2 image2-full-responsive" src="../../../../assets/images/login2.png">

      <div class="fx-layout-column fx-align-center-center" style="height: 100%;">

        <div class="fx-layout-row-wrap" style="width: 50%;">

          <div class="fx-flex-100">
            <mat-divider></mat-divider>
          </div>

          <div class="fx-flex-100 fx-align-center-center">
            <h1 id=welcome>BENVENUTO</h1>
          </div>

          <div class="fx-flex-100">
            <mat-divider></mat-divider>
          </div>


<!--        <div class="fx-flex-100 form-container">-->
<!--          <form [formGroup]=loginForm>-->

<!--            <div>-->
<!--              <span class="descr">Username</span>-->
<!--              <mat-form-field appearance="outline" style="width: 100%;">-->
<!--                <input matInput formControlName="username">-->
<!--              </mat-form-field>-->
<!--            </div>-->

<!--            <div>-->
<!--              <span class="descr">Password</span>-->
<!--              <mat-form-field appearance="outline" style="width: 100%;">-->
<!--                <input matInput [type]="hidePsw ? 'password' : 'text'">-->
<!--                <button mat-icon-button matSuffix (click)="hidePsw = !hidePsw">-->
<!--                  <mat-icon>{{hidePsw ? 'visibility_off' : 'visibility'}}</mat-icon>-->
<!--                </button>-->
<!--              </mat-form-field>-->

<!--            </div>-->

<!--          </form>-->
<!--        </div>-->

<!--        <div class="fx-flex-100 fx-align-center">-->
<!--          <button mat-raised-button color=warn (click)="onLogin()"><mat-icon>home</mat-icon>LOGIN</button>-->
<!--        </div>-->


      </div>

      </div>

    </div>

  </div>

</div>
